<!-- vertical-layout -->
@if (coreConfig.layout.type === 'vertical') {
  <block-ui>
    <vertical-layout></vertical-layout>
  </block-ui>
}
<!-- / vertical-layout -->

<!-- horizontal-layout -->
@if (coreConfig.layout.type === 'horizontal') {
  <block-ui>
    <horizontal-layout></horizontal-layout>
  </block-ui>
}
<!-- / horizontal-layout -->

<!-- theme customizer -->
@if (coreConfig.layout.customizer) {
  <core-sidebar
    name="themeCustomizer"
    class="customizer d-none d-md-block"
    [invisibleOverlay]="true"
    >
    <a
      class="customizer-toggle d-flex align-items-center justify-content-center"
      (click)="toggleSidebar('themeCustomizer')"
      >
      <span [data-feather]="'settings'" [class]="'spinner'"></span>
    </a>
    <core-theme-customizer></core-theme-customizer>
  </core-sidebar>
}
<!-- / theme customizer -->
